import React from 'react';
import { DialogRoute } from 'bernie-core';
import { Layer } from 'bernie-view';
import { UitkSheet } from 'uitk-react-sheet';
import { UitkToolbar } from 'uitk-react-toolbar';
import { useDialog } from "@shared-ui/dialog-context";

type props = {
    children: React.ReactNode,
    uniqueDialogId3: string, 
    exClass?: string,  
};

const GalleryDialogPopup = ({children,uniqueDialogId3, exClass=''}:props) => {
    const triggerRef = React.useRef();      
    const [, dialogActions] = useDialog("GalleryPopup");

    const onDismiss = () => {       
        dialogActions.closeDialog();
    }; 

    return <>
        <DialogRoute key="rout" id={uniqueDialogId3}>
          <Layer key="layer" id="lightbox" onDismiss={() =>  onDismiss()}>
            <UitkSheet
              key="light"
              className={`lightbox cp-popup ${exClass}`}
              isVisible={true}
              type="full"
              triggerRef={triggerRef}
            >
                <UitkToolbar
                    key="UitkToolbar"
                    navigationContent={{
                      onClick: onDismiss,
                      navIconLabel: 'Close the dialog',
                      navType: 'close'
                    }}
                />
                    {children}
            </UitkSheet>
          </Layer>
        </DialogRoute>    
    </>;
}; 

export default GalleryDialogPopup;